import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs, Search } from 'components';
import { Divider, Message, Header } from 'semantic';
import { useUser } from 'contexts/user';
import { userCanAccessProviderEndpoint } from '../../../utils/roles';
import { request } from 'utils/api';
import { useFeatures } from '../../../contexts/features';
import { Link } from 'react-router-dom';
import TrustTierTable from './Table';

export default function List() {
  const { t } = useTranslation();
  const { user, provider } = useUser();
  const { hasFeature, isReady } = useFeatures();

  const mspLimitsFeatureEnabled = hasFeature('provider_msp_limits');

  const readAccess = userCanAccessProviderEndpoint(
    user!,
    provider,
    'providers-msp-limits',
    'read'
  );

  if (!isReady || !mspLimitsFeatureEnabled || !readAccess) {
    return (
      <Message warning>
        {t(
          'access.cannotAccess',
          'This page is not available for you. Please contact your administrator.'
        )}
      </Message>
    );
  }

  const onDataNeeded = async () => {
    return request({
      method: 'GET',
      path: `/1/providers/${provider?.id}/msp-limits`,
    });
  };

  const searchRef = useRef(null);

  return (
    <Search.Provider onDataNeeded={onDataNeeded} ref={searchRef}>
      {() => (
        <>
          <Breadcrumbs
            path={[
              <Link key="cards" to="/cards">
                {t('cards.title', 'Cards')}
              </Link>,
            ]}
            active={t('mspLimits.title', 'MSP Limits')}
          />
          <Header as="h2" style={{ margin: '0' }}>
            {t('mspLimits.title', 'MSP Limits')}
          </Header>

          <Divider hidden />
          <Search.Status noResults={t('common.noResults', 'No Results')} />
          <TrustTierTable />
        </>
      )}
    </Search.Provider>
  );
}
